<script setup></script>

<template>
  <p class="section-text">
    <strong class="">To Whom it May Concern,</strong>
  </p>
  <p class="section-text">
    I am writing this letter to provide a character reference for <strong class="">Ashley Friel.</strong> I have had the
    privilege of knowing Ashley for 10 years, and during this time, I have had the opportunity to witness her
    outstanding qualities, integrity, and exceptional character.
  </p>
  <p class="section-text">
    Ashley is a person of high moral and ethical standards. She consistently demonstrates honesty, trustworthiness, and
    reliability in her endeavors. Whether it's in her personal life or professional pursuits, Ashley can always be
    counted on to act with integrity and adhere to the highest principles.
  </p>
  <p class="section-text">
    One of Ashley's most remarkable traits is her dedication and determination. When faced with challenges or obstacles,
    Ashley approaches them with a strong work ethic and a positive attitude. She is not only persistent but also
    resourceful, finding creative solutions to complex problems. This determination and resilience make Ashley an asset
    to any team or community.
  </p>
  <p class="section-text">
    Ashley is a compassionate and caring individual. She is always willing to lend a helping hand and support those in
    need. Whether it's volunteering for a charitable cause or offering a listening ear to a friend in distress, Ashley
    consistently demonstrates empathy and kindness.
  </p>
  <p class="section-text">
    I have no doubt that Ashley would excel in any endeavor she chooses to pursue. Her character and values make her an
    outstanding candidate for any opportunity that comes her way.
  </p>
  <p class="section-text mb-0">
    <strong class="">Sincerely,</strong><br />
    Michael Traina<br />
    <a href="mailto:mike@maintemp.ca">mike@maintemp.ca</a>
  </p>
</template>

<style lang="scss" scoped></style>
